import uiRouter from 'angular-ui-router';
import teamRequestsComponent from './teamRequests.component';
import teamRequestsService from './teamRequests.service';
import teamRequestsFormatters from './teamRequests.formatters';
import teamRequestsList from './teamRequestsList/teamRequestsList';
import teamRequestsFilters from './teamRequests.filters';
import teamRequestsModalApproveAll from './teamRequestsModalApproveAll/teamRequestsModalApproveAll';
import { ROUTES } from 'common/domain/routes';
import { STATES } from 'common/domain/states';

let teamRequestsModule = angular.module('vacations-absences.teamRequests', [
  uiRouter,
  teamRequestsList,
  teamRequestsModalApproveAll,
])

  .config(($stateProvider) => {
    'ngInject';
    $stateProvider
      .state(STATES.VACATIONS_ABSENCES.TEAM_REQUESTS, {
        url: ROUTES.VACATIONS_ABSENCES.TEAM_REQUESTS,
        component: 'teamRequests',
        data: {
          requiresAuth: true,
          requiresManager: true,
        },
        resolve: {
          /* @ngInject */
          isWageInProcess: (StatusAppCheckers) => StatusAppCheckers.isWageInProcess()
        }
      });
  })

  .component('teamRequests', teamRequestsComponent)

  .filter('filterRequests', teamRequestsFilters)

  .service('teamRequestsService', teamRequestsService)
  .service('teamRequestsFormatters', teamRequestsFormatters)

  .name;

export default teamRequestsModule;



// WEBPACK FOOTER //
// ./client/app/vacations-absences.module/features/teamRequests/teamRequests.js